export enum MediaValidationStatus {
  Valid = 'Valid',
  ExceedsMaximumSize = 'ExceedsMaximumSize',
  InvalidImageFileType = 'InvalidImageFileType',
  InvalidVideoFileType = 'InvalidVideoFileType',
  Invalid3dModelFileType = 'Invalid3dModelFileType',

  /** When drag-and-drop into Media Card was rejected, due to logic implemented in "customValidator" prop. */
  DropValidationFailed = 'DropValidationFailed',
  CorruptedFile = 'CorruptedFile',
  ExceedsMaximumDimensions = 'ExceedsMaximumDimensions',
  InvalidFileExtension = 'InvalidFileExtension',
}

export type MediaValidationResult =
  | SimpleMediaValidationResult<MediaValidationStatus.Valid>
  | ExceedsMaximumSizeValidationResult
  | InvalidFileTypeValidationResult<MediaValidationStatus.InvalidImageFileType>
  | InvalidFileTypeValidationResult<MediaValidationStatus.InvalidVideoFileType>
  | InvalidFileTypeValidationResult<MediaValidationStatus.InvalidFileExtension>
  | InvalidFileTypeValidationResult<MediaValidationStatus.Invalid3dModelFileType>
  | InvalidFileTypeValidationResult<MediaValidationStatus.CorruptedFile>
  | ExceedsMaximumDimensionsValidationResult;

interface SimpleMediaValidationResult<TStatus> {
  status: TStatus;
}

interface ExceedsMaximumSizeValidationResult
  extends SimpleMediaValidationResult<MediaValidationStatus.ExceedsMaximumSize> {
  maximumSize: number;
}

interface InvalidFileTypeValidationResult<TStatus>
  extends SimpleMediaValidationResult<TStatus> {
  extensions: string[];
}

interface ExceedsMaximumDimensionsValidationResult
  extends SimpleMediaValidationResult<MediaValidationStatus.ExceedsMaximumDimensions> {
  maxMegapixels: number;
}
